import * as R from 'ramda'

export const relationRoles = {
  BUSINESS_USER: 'Business User',
  DECISION_USER: 'Decision User',
  ECONOMIC_BUYER: 'Economic Buyer',
  ECONOMIC_DECISION_MAKER: 'Economic Decision Maker',
  EVALUATOR: 'Evaluator',
  EXECUTIVE_SPONSOR: 'Executive Sponsor',
  INFLUENCER: 'Influencer',
  TECHNICAL_BUYER: 'Technical Buyer',
  OTHER: 'Other'
}

export const rolesKeys = R.keys(relationRoles)

export const rolesValues = R.keys(relationRoles)
